import { createFileRoute } from '@tanstack/react-router'
import { KeyGate } from '@/crypto/KeyGate'
import { Console } from '@/features/console/Console'
import { roomSearch } from '@/lib/roomSearch'

/**
 * Console da sessão.
 *
 * O `id` da URL é o id da sessão marcada: o servidor lê a linha dela para
 * decidir quem entra como terapeuta. Os parâmetros de medição continuam
 * valendo aqui, porque é deste console que se mede a deriva.
 *
 * Dentro do `KeyGate` porque a tela registra SUD, VOC e nota rápida, e nada
 * disso existe com a chave trancada.
 */
export const Route = createFileRoute('/_app/app/s/$id')({
  validateSearch: roomSearch.pick({ measure: true, label: true }),
  // Vídeo e bolinha ocupam a tela toda, sem a caixa das outras páginas.
  staticData: { moldura: 'tela' },
  component: function SessionConsole() {
    const { id } = Route.useParams()
    const { measure, label } = Route.useSearch()
    return (
      <div data-surface="consultorio" className="h-full">
        <KeyGate>
          <Console key={id} sessionId={id} measure={measure} label={label ?? ''} />
        </KeyGate>
      </div>
    )
  },
})
